<template>
    <div>
        <ul class="search-filters-menu">
            <li class="search-filters-menu-item search-filters-menu-item__fias">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                <span class="search-filters-menu-item__header">Местоположение</span>
                <span
                    @click="showSingleFilter"
                    :class="{dashed: true, 'search-filter-show': true, active: this.$data.shownFilter.fias}"
                    data-filterType="fias">{{selectedFiltersText.fias}}</span>
            </li>

            <li class="search-filters-menu-item search-filters-menu-item__okved">
                <i class="fa fa-wrench" aria-hidden="true"></i>
                <span class="search-filters-menu-item__header">Вид деятельности</span>
                <span
                    @click="showSingleFilter"
                    class="dashed search-filter-show"
                    :class="{dashed: true, 'search-filter-show': true, active: this.$data.shownFilter.okved}"
                    data-filterType="okved">
                    {{selectedFiltersText.okved}}
                </span>
            </li>

            <li class="search-filters-menu-item search-filters-menu-item__okfs">
                <i class="fa fa-bank" aria-hidden="true"></i>
                <span class="search-filters-menu-item__header">Форма собственности</span>
                <span
                    @click="showSingleFilter"
                    class="dashed search-filter-show"
                    :class="{dashed: true, 'search-filter-show': true, active: this.$data.shownFilter.okfs}"
                    data-filterType="okfs">{{selectedFiltersText.okfs}}</span>
            </li>

            <li class="search-filters-menu-item search-filters-menu-item__okopf">
                <i class="fa fa-book" aria-hidden="true"></i>
                <span class="search-filters-menu-item__header">Организационно-правовая форма</span>
                <span
                    @click="showSingleFilter"
                    class="dashed search-filter-show"
                    :class="{dashed: true, 'search-filter-show': true, active: this.$data.shownFilter.okopf}"
                    data-filterType="okopf">{{selectedFiltersText.okopf}}</span>
            </li>

            <li class="search-filters-menu-item">
                <i class="fa fa-sliders" aria-hidden="true"></i>
                <span class="search-filters-menu-item__header">Прочие фильтры</span>
                <span
                    @click="showSingleFilter"
                    class="dashed search-filter-show"
                    :class="{dashed: true, 'search-filter-show': true, active: this.$data.shownFilter.all}"
                    data-filterType="all">{{selectedFiltersText.restFiltersText}}</span>
            </li>
        </ul>

        <show-result-button :clear="clear"/>
        
        <div>
            <classificator
                v-show="shownFilter.fias"
                title="Местоположение"
                registry="fias"
                inputPlaceholder="Адрес, почтовый индекс или код ОКАТО"
                :key="1"
                />

            <classificator
                v-show="shownFilter.okved"
                title="Вид деятельности"
                registry="okved"
                inputPlaceholder="Название вида деятельности или код ОКВЭД"
                :key="2"
                />

            <classificator
                v-show="shownFilter.okfs"
                title="Формы собственности"
                registry="okfs"
                inputPlaceholder="Название формы собственности"
                :key="3"
                />

            <div v-show="shownFilter.okopf" class="search-filter">
                <h2 class="search__filter-title">Организационно-правовая форма</h2>
                <div class="l-centered" style="margin-top: 20px;">
                    <div style="width: 100%; font-size: 0; text-align: center;">
                        <div class="filters-group" id="filter-okfs">
                            <div @click="changeRecType" class="filters-group-outer" :class="{active: rectype == 0}" data-rectype="0" style="width: 160px; border-radius: 4px 0 0 4px;">
                                Компании и ИП
                            </div>
                            <div @click="changeRecType" class="filters-group-outer" :class="{active: rectype == 1}" data-rectype="1" style="width: 160px; border-left: none; border-right: none; border-radius: 0;">
                                Только компании
                            </div>
                            <div @click="changeRecType" class="filters-group-outer" :class="{active: rectype == 2}" data-rectype="2" style="width: 160px; border-radius: 0 4px 4px 0;">
                                Только ИП
                            </div>
                        </div>
                    </div>
                </div>
                <div class="blocker">
                    <div class="blocker-screen" v-if="rectype"></div>
                    <classificator
                        registry="okopf"
                        inputPlaceholder="Название классификатора Организационно-правововой формы"
                        />
                </div>
            </div>

            <div v-show="shownFilter.all" id="filter-all" class="search-filter">
                <h2 style="text-align: center; margin-bottom: 40px;">Фильтры</h2>
                <div id="opf__all" class="l-centered" style="margin-top: 20px;">
                    <div style="width: 100%; font-size: 0; text-align: center;">
                        <div class="filters-group" id="filter-okfs">
                            <div @click="changeRecType" class="filters-group-outer" :class="{active: rectype == 0}" data-rectype="0" style="width: 160px; display: block; margin: 0 auto; border-bottom-right-radius: 0; border-bottom-left-radius: 0;">
                                Компании и ИП
                            </div>
                            <div @click="changeRecType" class="filters-group-outer" :class="{active: rectype == 1}" data-rectype="1" style="width: 160px; display: block; margin: 0 auto; border-radius: 0; border-top: 0; border-bottom: 0;">
                                Только компании
                            </div>
                            <div @click="changeRecType" class="filters-group-outer" :class="{active: rectype == 2}" data-rectype="2" style="width: 160px; display: block; margin: 0 auto; border-top-right-radius: 0; border-top-left-radius: 0;">
                                Только ИП
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%; font-size: 0; text-align: center;">
                    <div class="filters-column">
                        <div class="filters-group">
                            <div class="filters-group-label">Статус</div>
                            <div class="filters-group-outer" v-bind:class="{active: status != 'both'}">
                                <select @change="showResultsButtonFn" v-model="status">
                                    <option value="both">Действующие и ликвидированные</option>
                                    <option value="curr">Действующие</option>
                                    <option value="liqu">Ликвидированные</option>
                                </select>
                            </div>
                            <!-- <div class="filters-group-erase"><i class="lnr lnr-cross"></i></div> -->
                        </div>

                        <div class="filters-group">
                            <div class="filters-group-label">Дата регистрации</div>
                            <div v-bind:class="{active: dateStartFrom}" class="filters-group-outer" style="width: 120px; border-radius: 4px 0 0 4px;">
                                <input @keydown="showResultsButtonFn" v-model="dateStartFrom" data-type="dateStart" data-fromto="from" class="masked" id="filter-date-start-from" type="text" placeholder="c" />
                            </div>
                            <div v-bind:class="{active: dateStartTo}" class="filters-group-outer" style="width: 120px; border-radius: 0 4px 4px 0; border-left: none;">
                                <input @keydown="showResultsButtonFn" v-model="dateStartTo" data-type="dateStart" data-fromto="to" class="masked" id="filter-date-start-to" type="text" placeholder="по" />
                            </div>
                            <!-- <div class="filters-group-erase" id="filter-date-start-erase"><i class="lnr lnr-cross"></i></div> -->
                        </div>

                        <div class="filters-group" id="filter-date-stop-group">
                            <div class="filters-group-label">Дата ликвидации</div>
                            <div v-bind:class="{active: dateStopFrom}" class="filters-group-outer" style="width: 120px; border-radius: 4px 0 0 4px;">
                                <input @keydown="showResultsButtonFn" v-model="dateStopFrom" data-type="dateStop" data-fromto="from" class="masked" id="filter-date-stop-from" type="text" placeholder="c" />
                            </div>
                            <div v-bind:class="{active: dateStopTo}" class="filters-group-outer" style="width: 120px; border-radius: 0 4px 4px 0; border-left: none;">
                                <input @keydown="showResultsButtonFn" v-model="dateStopTo" data-type="dateStop" data-fromto="to" class="masked" id="filter-date-stop-to" type="text" placeholder="по" />
                            </div>
                            <!-- <div class="filters-group-erase" id="filter-date-stop-erase"><i class="lnr lnr-cross"></i></div> -->
                        </div>

                        <div class="filters-group" id="filter-contacts">
                            <div class="filters-group-label">С контактами</div>
                            <div v-bind:class="{active: phone}" class="filters-group-outer" style="width: 80px; border-radius: 4px 0 0 4px;">
                                <label for="filter-data-contacts-phone" class="filters-checkbox" id="filter-contacts-phone">Телефон</label>
                                <input @change="showResultsButtonFn" v-model="phone" value="phone" type="checkbox" name="filter-data-contacts" id="filter-data-contacts-phone" style="visibility: hidden">
                            </div>
                            <div v-bind:class="{active: site}" class="filters-group-outer" style="width: 80px; border-left: none; border-right: none; border-radius: 0;">
                                <label for="filter-data-contacts-site" class="filters-checkbox" id="filter-contacts-site">Сайт</label>
                                <input @change="showResultsButtonFn" v-model="site" value="site" type="checkbox" name="filter-data-contacts" id="filter-data-contacts-site" style="visibility: hidden">
                            </div>
                            <div v-bind:class="{active: email}" class="filters-group-outer" style="width: 80px; border-radius: 0 4px 4px 0;">
                                <label for="filter-data-contacts-email" class="filters-checkbox" id="filter-contacts-email">Эл. почта</label>
                                <input @change="showResultsButtonFn" v-model="email" value="email" type="checkbox" name="filter-data-contacts" id="filter-data-contacts-email" style="visibility: hidden">
                            </div>
                            <!-- <div class="filters-group-erase" id="filter-contacts-erase"><i class="lnr lnr-cross"></i></div> -->
                        </div>

                        <search-filter-checkbox buttonTitle="Есть связь по юр. адресу" type="registration_adress_contact"/>
                        <search-filter-checkbox buttonTitle="Сдана налоговая отчётность" type="nalog_otchet"/>
                        <search-filter-checkbox buttonTitle="Без задолженности по налогам" type="nalog_zadolj"/>
                        <div id="filter-license">
                            <search-filter-checkbox :group="true" type="license_alco" buttonTitle="Росалкогольрегулирование" title="Наличие лицензий"/>
                            <search-filter-checkbox :group="true" type="license_zdrav" buttonTitle="Росздравнадзор"/>
                            <search-filter-checkbox :group="true" type="license_kom" buttonTitle="Роскомнадзор"/>
                            <search-filter-checkbox :group="true" type="license_potreb" buttonTitle="Роспотребнадзор"/>
                            <search-filter-checkbox :group="true" type="license_prirod" buttonTitle="Росприроднадзор"/>
                            <search-filter-checkbox :group="true" type="license_teh" buttonTitle="Ростехнадзор"/>
                            <search-filter-checkbox :group="true" type="license_obr" buttonTitle="Рособрнадзор"/>
                            <search-filter-checkbox :group="true" type="license_min_cult" buttonTitle="МинКультуры"/>
                            <search-filter-checkbox :group="true" type="license_min_promtorg" buttonTitle="МинПромторг"/>
                        </div>
                    </div>

                    <div class="filters-column">
                        <search-money-filter title="Уставный капитал *" type="auth_capital"/>
                        <search-money-filter title="Выручка *" type="p21103"/>
                        <search-money-filter title="Основные средства *" type="p11503"/>
                        <search-money-filter title="Запасы *" type="p12103"/>
                        <search-money-filter title="Деб. задолженность *" type="p12303"/>
                        <search-money-filter title="Кред. задолженность *" type="p15203"/>
                        <search-money-filter title="Чистая прибыль *" type="p24003"/>
                        <search-money-filter title="Прибыль от продаж *" type="p22003"/>
                        <search-money-filter title="Прибыль до налога *" type="p23003"/>

                        <div class="filters-group">
                            <div class="filters-group-label">
                                * - используются данные за последний отчётный период
                            </div>
                        </div>
                        
                        <div class="filters-group">
                            <div class="filters-group-label">
                                Иски о банкротстве
                            </div>
                            <div class="filters-group-outer" v-bind:class="{active: bankrupts}">
                                <select @change="showResultsButtonFn" v-model="bankrupts">
                                    <option value="0">Не важно</option>
                                    <option value="1">Есть</option>
                                    <option value="2">Нет</option>
                                </select>
                            </div>
                        </div>
                        <div class="filters-group">
                            <div class="filters-group-label">
                                Бух. отчетность
                            </div>
                            <div class="filters-group-outer" v-bind:class="{active: boo_year}">
                                <select @change="showResultsButtonFn" v-model="boo_year">
                                    <option value="">Наличие за год</option>
                                    <option value="2018">2018</option>
                                    <option value="2017">2017</option>
                                    <option value="2016">2016</option>
                                    <option value="2015">2015</option>
                                    <option value="2014">2014</option>
                                    <option value="2013">2013</option>
                                    <option value="2012">2012</option>
                                    <option value="2011">2011</option>
                                    <option value="2010">2010</option>
                                    <option value="2009">2009</option>
                                    <option value="2008">2008</option>
                                    <option value="2007">2007</option>
                                    <option value="2006">2006</option>
                                    <option value="2005">2005</option>
                                    <option value="2004">2004</option>
                                    <option value="2003">2003</option>
                                    <option value="2002">2002</option>
                                    <option value="2001">2001</option>
                                </select>
                            </div>
                        </div>
                        <div class="filters-group">
                            <div class="filters-group-label">
                                Участие в ВЭД
                            </div>
                            <div class="filters-group-outer filters-group-outer__1x2" v-bind:class="{active: vedType}">
                                <select @change="showResultsButtonFn" v-model="vedType">
                                    <option value="">Тип</option>
                                    <option value="1">Контрактодержатель</option>
                                    <option value="2">Декларант</option>
                                    <option value="3">Получатель</option>
                                    <option value="4">Отправитель</option>
                                </select>
                            </div>
                            <div class="filters-group-outer filters-group-outer__2x2" v-bind:class="{active: vedYear}">
                                <select @change="showResultsButtonFn" v-model="vedYear">
                                    <option value="">Год</option>
                                    <option value="2015">2015</option>
                                    <option value="2014">2014</option>
                                    <option value="2013">2013</option>
                                    <option value="2012">2012</option>
                                    <option value="2011">2011</option>
                                    <option value="2010">2010</option>
                                    <option value="2009">2009</option>
                                    <option value="2008">2008</option>
                                    <option value="2007">2007</option>
                                    <option value="2006">2006</option>
                                    <option value="2005">2005</option>
                                    <option value="2004">2004</option>
                                    <option value="2003">2003</option>
                                    <option value="2002">2002</option>
                                    <option value="2001">2001</option>
                                    <option value="2000">2000</option>
                                    <option value="1999">1999</option>
                                    <option value="1998">1998</option>
                                </select>
                            </div>
                        </div>
                        <div class="filters-group">
                            <div class="filters-group-label">
                                Арбитражи
                            </div>
                            <div class="filters-group-outer filters-group-outer__1x2" v-bind:class="{active: kadType != 'noselect'}">
                                <select @change="showResultsButtonFn" v-model="kadType">
                                    <option value="noselect">Тип</option>
                                    <option value="0">Истец</option>
                                    <option value="1">Ответчик</option>
                                    <option value="2">3я сторона</option>
                                </select>
                            </div>
                            <div class="filters-group-outer filters-group-outer__2x2" v-bind:class="{active: kadYear}">
                                <select @change="showResultsButtonFn" v-model="kadYear">
                                    <option value="">Год</option>
                                    <option value="2019">2019</option>
                                    <option value="2018">2018</option>
                                    <option value="2017">2017</option>
                                    <option value="2016">2016</option>
                                    <option value="2015">2015</option>
                                    <option value="2014">2014</option>
                                    <option value="2013">2013</option>
                                    <option value="2012">2012</option>
                                    <option value="2011">2011</option>
                                    <option value="2010">2010</option>
                                    <option value="2009">2009</option>
                                    <option value="2008">2008</option>
                                    <option value="2007">2007</option>
                                    <option value="2006">2006</option>
                                    <option value="2005">2005</option>
                                    <option value="2004">2004</option>
                                    <option value="2003">2003</option>
                                    <option value="2002">2002</option>
                                    <option value="2001">2001</option>
                                    <option value="2000">2000</option>
                                    <option value="1999">1999</option>
                                    <option value="1998">1998</option>
                                </select>
                            </div>
                        </div>
                        <div class="filters-group">
                            <div class="filters-group-label">
                                Размер предприятия
                            </div>
                            <div class="filters-group-outer" :class="{ active: msp }">
                                <select @change="showResultsButtonFn" v-model="msp">
                                    <option :value="0">Все предприятия</option>
                                    <option :value="10">Микро</option>
                                    <option :value="11">Малые</option>
                                    <option :value="12">Средние</option>
                                    <!-- <option :value="2">Прочие</option> -->
                                </select>
                            </div>
                        </div>
                        <div class="filters-group" v-if="showEmployeeCount">
                            <div class="filters-group-label">Кол-во сотрудников</div>
                            <div class="filters-group-outer" style="width: 120px; border-radius: 4px 0 0 4px;">
                                <input v-model="employeeCountFrom" data-fromto="from" type="text" placeholder="от" />
                            </div>
                            <div class="filters-group-outer" style="width: 120px; border-radius: 0 4px 4px 0; border-left: none;">
                                <input v-model="employeeCountTo" data-fromto="to" type="text" placeholder="до" />
                            </div>
                            <!-- <div class="filters-group-erase" @click="eraseFilter('employeeCount')"><i class="lnr lnr-cross"></i></div> -->
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import classificator from './classificator.vue'
import searchFilterCheckbox from './searchFilterCheckbox.vue'
import searchMoneyFilter from './searchMoneyFilter.vue'
import showResultsButtonVue from './showResultsButton.vue';

export default {
    data(){
        return {
            shownFilter:{
                fias: false,
                okved: false,
                okfs: false,
                okopf: false,
                all: false
            }
        }
    },
    methods: {
        showResultsButtonFn() {
            this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value: true })
        },
        clear() {
            Object.keys(this.$data.shownFilter)
                .forEach(e => {this.$data.shownFilter[e] = false})
        },
        showSingleFilter(e) {
            const type = e.target.getAttribute('data-filterType')
            if(this.$data.shownFilter[type]) {
                this.clear()
            } else {
                this.clear()
                this.$data.shownFilter[type] = true
            }
        },
        changeRecType(e){
            this.$store.commit("search/setFilterData", { type: "rectype", value: Number(e.target.dataset.rectype) })
        }
    },
    components: {
        "classificator": classificator,
        "search-filter-checkbox": searchFilterCheckbox,
        "search-money-filter": searchMoneyFilter,
        "show-result-button": showResultsButtonVue
    },
    computed: {
        showEmployeeCount() { return this.$store.state.specialPriviliges.employeeCount.includes(this.$store.state.apiUser)},
        selectedFiltersText(){ return this.$store.getters['search/selectedFiltersText'] },
        kadType: {
            get() { return this.$store.state.search.filterData.kad.type },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'kad',
                    object_key: 'type'
                }
            )}
        },
        kadYear: {
            get() { return this.$store.state.search.filterData.kad.year },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'kad',
                    object_key: 'year'
                }
            )}
        },
        vedType: {
            get() { return this.$store.state.search.filterData.ved.type },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'ved',
                    object_key: 'type'
                }
            )}
        },
        vedYear: {
            get() { return this.$store.state.search.filterData.ved.year },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'ved',
                    object_key: 'year'
                }
            )}
        },
        boo_year: {
            get(){ return this.$store.state.search.filterData.boo_year },
            set(value){ this.$store.commit("search/setFilterData", { type: "boo_year", value }) }
        },
        bankrupts: {
            get(){ return this.$store.state.search.filterData.bankrupts },
            set(value){ this.$store.commit("search/setFilterData", { type: "bankrupts", value: Number(value) }) }
        },
        registration_adress_contact: {
            get(){ return this.$store.state.search.filterData.registration_adress_contact },
            set(value){ this.$store.commit("search/setFilterData", { type: "registration_adress_contact", value }) }
        },
        phone: {
            get(){ return this.$store.state.search.filterData.phone },
            set(value){ this.$store.commit("search/setFilterData", { type: "phone", value }) }
        },
        email: {
            get(){ return this.$store.state.search.filterData.email },
            set(value){ this.$store.commit("search/setFilterData", { type: "email", value }) }
        },
        site: {
            get(){ return this.$store.state.search.filterData.site },
            set(value){ this.$store.commit("search/setFilterData", { type: "site", value }) }
        },
        status: {
            get(){ return this.$store.state.search.filterData.status },
            set(value){ this.$store.commit("search/setFilterData", { type: "status", value }) }
        },
        rectype(){ return this.$store.state.search.filterData.rectype },
        selectedClassificator(){ return this.$store.state.search.classificator },
        selectedFiltersCount(){ return this.$store.getters['search/selectedFiltersCount'] },
        dateStartFrom: {
            get() { return this.$store.state.search.filterData.dateStart.from },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'dateStart',
                    object_key: 'from'
                }
            )}
        },
        dateStartTo: {
            get() { return this.$store.state.search.filterData.dateStart.to },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'dateStart',
                    object_key: 'to'
                }
            )}
        },
        employeeCountFrom: {
            get() { return this.$store.state.search.filterData.employeeCount.from },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'employeeCount',
                    object_key: 'from'
                }
            )}
        },
        employeeCountTo: {
            get() { return this.$store.state.search.filterData.employeeCount.to },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'employeeCount',
                    object_key: 'to'
                }
            )}
        },
        dateStopFrom: {
            get() { return this.$store.state.search.filterData.dateStop.from },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'dateStop',
                    object_key: 'from'
                }
            )}
        },
        dateStopTo: {
            get() { return this.$store.state.search.filterData.dateStop.to },
            set(value) {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: 'dateStop',
                    object_key: 'to'
                }
            )}
        },
        msp: {
            get() { return this.$store.state.search.filterData.msp },
            set(value) {
                this.$store.commit("search/setFilterData", { type: "msp", value: Number(value) })
            }
        }
    },
    mounted(){
        $("#filter-date-start-from, #filter-date-start-to, #filter-date-stop-from, #filter-date-stop-to").datepicker({
            showOtherMonths: true,
            selectOtherMonths: true,
            changeMonth: true,
            changeYear: true,
            dateFormat: "dd.mm.yy",
            maxDate: "+0",
            showWeek: false,
            firstDay: 1,
            dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
            monthNamesShort: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сен", "Окт", "Ноя", "Дек"],
            onSelect: (value, evt) => {
                this.$store.commit('search/setValueInsideFilterDataObject', {
                    value,
                    type: $(evt.input).data('type'),
                    object_key: $(evt.input).data('fromto')
                })
            }
        })
    }
}
</script>

<style scoped>

.filters-group-outer__1x2 {
    width: 120px;
    border-radius: 4px 0px 0px 4px;
}

.filters-group-outer__2x2 {
    width: 120px;
    border-radius: 0px 4px 4px 0px;
    border-left: none;
}
label {
    margin-left: 0;
}
.blocker {
    position: relative;
}
.blocker-screen {
    width: 100%;
    height: 100%;
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,.5);
    cursor: not-allowed;
}
.selectedClassificator {
    font-size: 12px;
    position: relative;
    width: 20px;
    display: inline-block;
    top: 1px;
    left: -1px;
    height: 18px;
    text-align: left;
}
.search-filters-menu-item {
	display: inline-block;
	margin: 0 5px 0 0 !important;
	padding: 0 !important;
	font-size: 16px;
	color: #6b676d;
}
.search-filters-menu-item span { font-weight: 700; }
.search-filters-menu-item i { margin-right: 5px; }
.search-filter {
    position: relative;
    border-radius: 4px;
    padding: 20px 20px;
    background:rgb(253, 244, 214);
    margin-top: 20px;
}
.search-filter h2 { font-family: 'PT Serif', serif; font-size: 32px; }
.search-filter-close { position: absolute; top: 28px; right: 30px; font-size: 36px; font-weight: 100; width: 36px; height: 36px; text-align: center; line-height: 36px; cursor: pointer; color: #ddd; }
.search-filter-close:hover { color: rgba(255,50,50,1.0); }
</style>